import React from 'react';

interface Props {
  children?: React.ReactNode;
  className?: string;
  [key: string]: any;
}

export default function RastreamentoLink({ children, className, ...rest }: Props) {
  return (
    <a
      href="https://cliente.delps.net/rastreamento"
      target="_blank"
      rel="noreferrer"
      className={className}
      {...rest}
    >
      {children}
    </a>
  );
}
